import React, { useEffect, useState } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import kebabCase from "modules/kebabCase";

import RequiredMark from "components/RequiredMark";

const Select = ({
  className,
  handleChange,
  isInvalid,
  label,
  name,
  quidBase,
  required = false,
  source,
  t,
  value,
}) => {
  const [selectedValue, setSelectedValue] = useState(value);

  const inputProps = {
    className: "text-field__input",
    "data-quid": `${quidBase}-select`,
    value,
    name,
  };

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelectChange = (event) => {
    const newValue = event.target?.value;
    setSelectedValue(newValue);
    handleChange(newValue);
  };

  return (
    <div
      className={classNames(
        "form__control-group text-field",
        className,
        isInvalid && "error"
      )}
      data-quid={quidBase}
    >
      <label
        className="text-field__label"
        data-quid={`${quidBase}-label`}
        htmlFor={name}
      >
        {required && <RequiredMark />} {label}
      </label>

      <select
        {...inputProps}
        className={classNames(
          "text-field__input",
          isInvalid && "parsley-error"
        )}
        value={selectedValue}
        onChange={handleSelectChange}
        required={required}
      >
        {Object.entries(source).map(([key, option]) => (
          <option data-quid={kebabCase(key)} key={key} value={key}>
            {option}
          </option>
        ))}
      </select>
      {isInvalid && t && (
        <p
          className="error-message parsley-required"
          data-quid={`${quidBase}-${kebabCase(name)}-error`}
        >
          {t("negative:please_enter_a_valid_value", {
            value: label.toLowerCase(),
          })}
        </p>
      )}
    </div>
  );
};

Select.propTypes = {
  className: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  isInvalid: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  quidBase: PropTypes.string.isRequired,
  required: PropTypes.bool,
  source: PropTypes.objectOf(PropTypes.string),
  t: PropTypes.func,
  value: PropTypes.string,
};

Select.defaultProps = {
  className: "grid__cell--1",
  isInvalid: false,
  source: {},
  translations: true,
  value: "",
};

export default Select;
